import script from "./AppSnackbar.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppSnackbar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSnackbar.vue.js?vue&type=script&setup=true&lang=js!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppSnackbar.vue?vue&type=script&setup=true&lang=js"

import "./AppSnackbar.vue.scss?vue&type=style&index=0&id=2b0f84e0&lang=scss!=!../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./AppSnackbar.vue?vue&type=style&index=0&id=2b0f84e0&lang=scss"

const __exports__ = script;

export default __exports__